var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 15.1667C4.04659 15.1667 0.833252 11.9534 0.833252 8.00004C0.833252 4.04671 4.04659 0.833374 7.99992 0.833374C11.9533 0.833374 15.1666 4.04671 15.1666 8.00004C15.1666 11.9534 11.9533 15.1667 7.99992 15.1667ZM7.99992 1.83337C4.59992 1.83337 1.83325 4.60004 1.83325 8.00004C1.83325 11.4 4.59992 14.1667 7.99992 14.1667C11.3999 14.1667 14.1666 11.4 14.1666 8.00004C14.1666 4.60004 11.3999 1.83337 7.99992 1.83337Z",
    fill: "#C63838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11332 10.3867C5.98666 10.3867 5.85999 10.34 5.75999 10.24C5.56666 10.0467 5.56666 9.72666 5.75999 9.53332L9.53332 5.75999C9.72666 5.56666 10.0467 5.56666 10.24 5.75999C10.4333 5.95332 10.4333 6.27332 10.24 6.46666L6.46666 10.24C6.37332 10.34 6.23999 10.3867 6.11332 10.3867Z",
    fill: "#C63838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88666 10.3867C9.75999 10.3867 9.63332 10.34 9.53332 10.24L5.75999 6.46666C5.56666 6.27332 5.56666 5.95332 5.75999 5.75999C5.95332 5.56666 6.27332 5.56666 6.46666 5.75999L10.24 9.53332C10.4333 9.72666 10.4333 10.0467 10.24 10.24C10.14 10.34 10.0133 10.3867 9.88666 10.3867Z",
    fill: "#C63838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.0eae1eecaab90c9d62e8e7ba0a4b3dbb.svg";
export { ForwardRef as ReactComponent };